/* Seolla: scroll reveal, accordions, counters */
(function () {
  if (window.__seCoreLoaded) return;
  window.__seCoreLoaded = true;

  document.documentElement.classList.add('se-js');
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var inEditor = !!(window.Shopify && window.Shopify.designMode);

  function initReveal(root) {
    var els = (root || document).querySelectorAll('.se-reveal:not(.is-visible)');
    if (!els.length) return;
    if (!('IntersectionObserver' in window) || reduce || inEditor) {
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    setTimeout(function () { els.forEach(function (el) { el.classList.add('is-visible'); }); }, 2500);
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { entry.target.classList.add('is-visible'); io.unobserve(entry.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
    els.forEach(function (el) { io.observe(el); });
  }

  function initCounters(root) {
    var els = (root || document).querySelectorAll('[data-se-count]:not(.is-counted)');
    if (!els.length) return;
    function run(el) {
      el.classList.add('is-counted');
      var target = parseFloat(el.getAttribute('data-se-count'));
      if (isNaN(target) || reduce) return;
      var suffix = el.getAttribute('data-se-suffix') || '';
      var start = null, dur = 1400;
      function step(ts) {
        if (!start) start = ts;
        var p = Math.min(1, (ts - start) / dur);
        var e = 1 - Math.pow(1 - p, 3);
        el.textContent = Math.round(target * e) + suffix;
        if (p < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    }
    if (!('IntersectionObserver' in window)) { els.forEach(run); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { run(entry.target); io.unobserve(entry.target); }
      });
    }, { threshold: 0.4 });
    els.forEach(function (el) { io.observe(el); });
  }

  function initAccordions(root) {
    (root || document).querySelectorAll('[data-se-accordion]').forEach(function (acc) {
      if (acc.__seBound) return;
      acc.__seBound = true;
      acc.addEventListener('toggle', function (e) {
        var d = e.target;
        if (!d.open || acc.getAttribute('data-se-accordion') !== 'single') return;
        acc.querySelectorAll('details[open]').forEach(function (o) { if (o !== d) o.open = false; });
      }, true);
    });
  }

  function initVideos(root) {
    (root || document).querySelectorAll('.se-ingr__media video, video[data-se-video]').forEach(function (v) {
      if (v.__seBound) return;
      v.__seBound = true;
      v.muted = true; v.loop = true; v.playsInline = true;
      v.addEventListener('playing', function () { v.classList.add('is-playing'); });
      if (v.readyState >= 3 && !v.paused) v.classList.add('is-playing');
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) { if (e.isIntersecting) { var p = v.play(); if (p && p.catch) p.catch(function () {}); } else { v.pause(); } });
        }, { rootMargin: '200px 0px' });
        io.observe(v);
      } else { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
    });
  }

  function initHighlights(root) {
    var els = (root || document).querySelectorAll('.se-hl:not(.is-on)');
    if (!els.length) return;
    if (!('IntersectionObserver' in window) || reduce) { els.forEach(function (el) { el.classList.add('is-on'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { entry.target.classList.add('is-on'); io.unobserve(entry.target); }
      });
    }, { rootMargin: '0px 0px -25% 0px', threshold: 0.6 });
    els.forEach(function (el) { io.observe(el); });
  }

  function init(root) { initReveal(root); initCounters(root); initAccordions(root); initVideos(root); initHighlights(root); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  window.seInit = init;
})();
